import { __assign } from "tslib";
import React from 'react';
import DropdownStateManager, { DropdownStateContext, } from '../../Dropdown/DropdownStateManager';
import FolderDropdownContent from './FolderDropdownContent';
var FolderDropdownMobile = function (props) { return (React.createElement(DropdownStateManager, null,
    React.createElement(DropdownStateContext.Consumer, null, function (_a) {
        var isOpen = _a.isOpen, openDropdown = _a.openDropdown, closeDropdown = _a.closeDropdown;
        return (React.createElement(FolderDropdownContent, __assign({}, props, { isOpen: isOpen, openDropdown: openDropdown, closeDropdown: closeDropdown })));
    }))); };
FolderDropdownMobile.displayName = 'FolderDropdownMobile';
export default FolderDropdownMobile;
//# sourceMappingURL=FolderDropdownMobile.js.map